import { useSnackbar } from 'vue3-snackbar'

class SnackbarHelperService {
  public snackbar?: any = undefined
  constructor() {}

  public init(): void {
    this.snackbar = useSnackbar()
  }

  public show(text: string, isError: boolean = true): void {
    this.snackbar.add({
      type: isError ? 'error' : 'success',
      text: text
    })
  }
}
export default new SnackbarHelperService()
